export function maxSelectableBoards(): number {
  return 20;
}
